import DropdownSelect from 'components/Common/DropdownSelect/DropdownSelect';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store';
import fetchStudioSearchResultsOperation from 'store/studioSearch/operation/fetchStudioSearchResultsOperation';
import setStudioSearchPageNrOperation from 'store/studioSearch/operation/setSearchPageNrOperation';
import setStudioSearchSortByOperation from 'store/studioSearch/operation/setSearchSortByOperation';
import getStudioSearchSortBy from 'store/studioSearch/selector/getStudioSearchSortBy';
import { setStudioSearchRefetchFlagAction } from 'store/studioSearch/slice';
import { sortOptions } from '../constants';

const DropdownSort: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const sortBy = useSelector(getStudioSearchSortBy);

  const changeSortBy = (sort: string) => {
    dispatch(setStudioSearchSortByOperation(sort));
    dispatch(setStudioSearchPageNrOperation(1));
    dispatch(setStudioSearchRefetchFlagAction(true));
    dispatch(fetchStudioSearchResultsOperation());
  };

  return (
    <DropdownSelect
      label={t('txt_sorting_by')}
      titleDecorator={t}
      options={sortOptions}
      selected={sortBy}
      onChange={changeSortBy}
    />
  );
};

export default DropdownSort;
